import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ForgotPasswordResponse } from './forgot-password.model';

@Injectable({
  providedIn: 'root'
})

export class ForgotPasswordService {
  constructor(private http: HttpClient,
    @Inject('API_URL') private apiUrl: string,
  ) { }

  public sendPassword(email: string = null): Observable<ForgotPasswordResponse> {
    return this.http.post<any>(this.apiUrl + 'auth/reset-password/send-mail', {}, {
      params: new HttpParams().set('email', email)
    });
  }
}
